// Forms whose submissions are listed in the admin. `id` matches the `form`
// value stored with each submission and is used as the URL segment.
export const formSubmissionForms = [
  { id: '20270322-banking-finance-in-the-age-of-ai', label: 'Banking & Finance in the Age of AI (22 Mar 2027)' },
];
